import { array, nullish, object } from 'valibot'
import { richTextData, singleLineData } from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'

const schema = crystallizeDocumentSchema(
  'register-user',
  object({
    steps: nullish(
      array(
        object({
          id: nullish(singleLineData),
          title: nullish(singleLineData),
          description: nullish(richTextData),
          nextLabel: nullish(singleLineData),
          previousLabel: nullish(singleLineData),
        }),
      ),
    ),
  }),
)

export function useRegisterUserCmsData() {
  const queryOptions = useCatalogueQueryOptions({ path: '/registrer-bedrift', schema })

  return useQuery(queryOptions)
}
